import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import ServiceForm from "./ServiceForm";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import InputPassword from "../../helpers/InputPassword";
import OnlineForm from "./OnlineForm";


function Online(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;




    const [row, setRow] = useState({
        fak_kontrahenci_id:  defId,  
        username: '',
        password: '',
    });


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

        fak_kontrahenci_id:  defId,  

        username:  props.mainView.readFilter('username',''),   

        new_username: '',
        new_password: '',
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'umowa nieaktywna',
            filter: {  filed: "stan_umowy", set: "2", typ: "combo"  },
        },
    ]);



    
        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }

        const valChangeListener2 = (filedName, val, correct, msg) => {
          
            setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                                                       
        }

        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('username', '');
            

            var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            setFilterParam({
                
                fak_kontrahenci_id:  defId, 

                username: '',                 
             
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }



          const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
            }


            const onBack = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });               
                }

            
            const onSuccess = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });       
                    getTab();
                }

         
                
      const saveData = () => {
              
               
               
                if(row.username.length < 2)
                {
                    // props.mainView.showDialog( "Ups!", "Podaj prawidłowy login / adres e-mail" , "error" , null);  
                     return;
                }

                if(row.password.length < 2) 
                {
                  //  props.mainView.showDialog( "Ups!", "Podaj prawidłowe hasło" , "error" , null);  
                    return;
                }
              
 


               props.mainView.showProgress();


                fetch( Config.url + '/rest_v1_home,user_onine_add', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                    
                            props.mainView.hideProgress();

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                               getTab();     
                               setView({...view, ["v"]:"list", ["id"]:-1 });                                                                                                
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            props.mainView.hideProgress();
                });
                        

                return false;
            }



    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_home,users_online', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }



        const deleteRecord = (e) => {
                
                var id = e.target.getAttribute('atr-id');
                var title = e.target.getAttribute('atr-title');

                props.mainView.showDialog("Pytanie" , "Czy na pewno chcesz usunąć: " + title  ,  "yesno"  , ( resp) => {
                              
                                if(resp == "yes")
                                {
                                    //-----------------
                                
                                        props.mainView.showProgress();        

                                                fetch( Config.url + '/rest_v1_home,service_remove', {
                                                    method: 'POST', 
                                                    body: JSON.stringify({id: id}), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => { 

                                                            props.mainView.hideProgress();

                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                            }else    
                                                            {
                                                                      getTab();
                                                                      props.mainView.showDialog( "Sukces", "Usługa została usunięta z umowy", "ok" , null);                                        
                                                            }
                                                } )
                                                .catch(err => {          
                                                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                            props.mainView.hideProgress();
                                                });

                                    //-----------------
                                }
                })

            }



       const keyListener = (e)     => {

                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }

       }


       useEffect( ()=>{

            if(Config.env == "dev") console.log("Online.js, listener on");
            window.onkeydown = keyListener;                       
            
            return () => {   
                 if(Config.env == "dev") console.log("Online.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);
    }



    if(tab == null)
    {
        setTab([]);
        getTab();    
        return <div>
            ...
        </div>
    }





    var dialog = null;

    if(view.v == "new")
    {
        dialog =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Nowy użytkownik</div>
                        <div className="dlg_msg" >
                            

                                <form className="eFormNone">
                                              <div className="form_tab">

                                                        <div className="form_control">
                                                                <div className="fieldName">Username / e-mail*</div>
                                                                <InputText   userData={props.userData} value={row.username} err={null}  valChange={valChangeListener2} goNext={goNextNew} name="username" placeholder={"Username / e-mail"} className=' w300 ' req='0' firstUp="0" />
                                                        </div>

                                                         <div className="form_control">
                                                                <div className="fieldName">Hasło (8 znaków, DUŻĘ małe litery, cyfry i znak specjalnych)*</div>
                                                                <InputPassword   userData={props.userData} value={row.password} err={null}  valChange={valChangeListener2} goNext={goNextNew} name="password" placeholder={"Hasło"} className=' w300 ' req='0' firstUp="0" />
                                                        </div>
                                              </div>
                                </form>
                          
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={saveData}>dodaj</div>
                        </div>
        </div>
 
    }
    




    if(view.v == "edit")
    {       
        return <OnlineForm userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }


    
    document.title = "Lista usług";


            var sortList = [                
            {column: "created_at", name: "Data utworzenia"  },         
            {column: "nazwa", name: "Nazwa"  },
            ]


    var titleRaport = "Użytkownicy online";
    

    return  <div className="view_content">
             

            <h3 className="dash_header">Użytkownicy online</h3>


                        <div className="bg_center">

                                     <div className="table_widget">
                                          <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj [+]</div>
                                    </div>


                                <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                           
                                                <td>Konto aktywne</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                                    
                                                                                                                              
                                                <td className="td_right">Podpięty do</td>                                                                                                                                                                                                                       
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                           
                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.is_active == '0') rowStyle = rowStyle + " color_deleted ";

                                                     

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>
                                                                <td  className="gocenter" v="edit" id={row.id} onClick={changeView} >
                                                                    {
                                                                      row.is_active == '1' &&
                                                                      <span>Tak</span>
                                                                    }
                                                                     {
                                                                      row.is_active == '0' &&
                                                                      <span>Nie</span>
                                                                    }
                                                                </td>
                                                                <td className="gocenter" v="edit" id={row.id} onClick={changeView} >{row.username}</td>
                                     
                                                                <td className="gocenter goright"> {row.grupa.nazwa1}</td>                                                       
                                                                <MenuTable>
                                                                    <ul>                                                                     
                                                                        <li v="edit" id={row.id} onClick={changeView}>Szczegóły</li>                                                                       
                                                                        <li> <a href={ "https://online.info800.pl/index.php5?controller=panel&caction=login&INPUT[userid]=" + row.id + "&log=ok" } target="_blank" className="link_color"  >Zaloguj się</a>  </li>                                                                       
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>


                        </div>
           {dialog}
        </div>


}

export default Online;